import Login from './Website/auth/Login/Login';
import Header from './Website/components/MainComps/Header/Header';
import ProductCode from './Website/pages/ProductCode/ProductCode';
import Categories from './Website/pages/Categories/Categories';
import Home from './Website/pages/Home/Home';
import CustomerBillingAddress from './Website/auth/CustomerBillingAddress/CustomerBillingAddress';
import CustomerRegn from './Website/auth/CustomerRegn/CustomerRegn';
import ManufactureSel from './Website/auth/ManufactureSel/ManufactureSel';
import VendorBillingAddress from './Website/auth/VendorBillingAddress/VendorBillingAddress';
import VendorRegn from './Website/auth/VendorRegn/VendorRegn';
import RegisterSelection from './Website/auth/RegisterSelection/RegisterSelection';
import AboutUs from './Website/pages/AboutUs/AboutUs';
import Cart from './Website/pages/Cart/Cart';
import Checkout from './Website/pages/Checkout/Checkout';
import BomManage from './Website/pages/BomManage/BomManage';
import QuoteRequest from './Website/pages/QuoteRequest/QuoteRequest';
import ForgotPassword from './Website/auth/ForgotPassword/ForgotPassword';
import ResetPassword from './Website/auth/ResetPassword/ResetPassword';
import ResetSuccess from './Website/auth/ResetSuccess/ResetSuccess';
import VerifyEmail from './Website/auth/VerifyEmail/VerifyEmail';
import { ToastContainer, toast } from 'react-toastify';
import Contact from './Website/pages/Contact/Contact';
import CrossRefer from './Website/pages/CrossRefer/CrossRefer';
import BomListing from './Website/pages/BomListing/BomListing';
import ProdComparision from './Website/pages/ProdComparision/ProdComparision';
import ExInventoryBuyItem from './Website/pages/ExInventoryBuyItem/ExInventoryBuyItem';
import ExInventoryUpload from './Website/pages/ExInventoryUpload/ExInventoryUpload';
import FileUploadPreview from './Website/pages/FileUploadPreview/FileUploadPreview';
import ExInvFileUploadPreview from './Website/pages/ExInvFileUploadPreview/ExInvFileUploadPreview';
import ExInventoryListing from './Website/pages/ExInventoryListing/ExInventoryListing';
import ExInventEnquiryForm from './Website/pages/ExInventEnquiryForm/ExInventEnquiryForm';
import WizardEnquiryForm from './Website/pages/WizardEnquiryForm/WizardEnquiryForm';
import WizardUpload from './Website/pages/WizardUpload/WizardUpload';
import FAQ from './Website/pages/faq/FAQ';
import Service from './Website/pages/service/Service';
import Manufacturers from './Website/pages/manufacturers/Manufacturers';
import Subcategories from './Website/pages/SearchList/Subcategories';
import ProductList from './Website/pages/ProductList/ProductList';
import Breadcrumbs from './Website/components/Breadcrumbs/Breadcrumbs';
import SchedulePO from './Website/pages/SchedulePO/SchedulePO';
import ScheduleAddCart from './Website/pages/ScheduleAddCart/ScheduleAddCart';
import ScheduleCart from './Website/pages/ScheduleCart/ScheduleCart';
import Myprofile from './Dashboard/CustomerDash/Pages/myprofile/Myprofile';
import AddNewUser from './Dashboard/CustomerDash/Pages/addNewUser/AddNewUser';
import Vendorprofile from './Dashboard/VendorDash/Pages/vendorprofile/Vendorprofile';
import AddNewVendor from './Dashboard/VendorDash/Pages/addNewVendor/AddNewVendor';
import VendorNotifications from './Dashboard/VendorDash/Pages/VendorNotifications';
import UserNotifications from './Dashboard/CustomerDash/Pages/UserNotifications';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerProfileThunk } from './Website/redux/customerSlice';
import { getNotificationCount } from './Website/redux/notification';
import { useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ProfileBody from './Dashboard/CustomerDash/Components/profilebody/ProfileBody';
import ScrollToTop from './ScrollToTop';
import AllEnquires from './Dashboard/CustomerDash/Pages/allEnquires/AllEnquires';
import EnquiryDetails from './Dashboard/CustomerDash/Pages/allEnquires/EnquiryDetails';
import CuSchedulePO from './Dashboard/CustomerDash/Pages/SchedulePO/CuSchedulePO';
import PODetails from './Dashboard/CustomerDash/Pages/SchedulePO/PODetails';
import Accountusers from './Dashboard/CustomerDash/Pages/addNewUser/Accountusers';
import Reshedule from './Dashboard/CustomerDash/Pages/SchedulePO/Reshedule';
import AllOrders from './Dashboard/CustomerDash/Pages/Orders/AllOrders';
import OrderDetails from './Dashboard/CustomerDash/Pages/Orders/OrderDetails';
import AllVenEnquires from './Dashboard/VendorDash/Pages/allVenEnquires/AllVenEnquires';
import VenEnquiryDetails from './Dashboard/VendorDash/Pages/allVenEnquires/VenEnquiryDetails';
import AllVenOrders from './Dashboard/VendorDash/Pages/VenOrders/AllVenOrders';
import VenOrderDetails from './Dashboard/VendorDash/Pages/VenOrders/VenOrderDetails';
import VenPODetails from './Dashboard/VendorDash/Pages/VenOrders/VenPODetails';
import EditAccountUser from './Dashboard/CustomerDash/Pages/addNewUser/EditAccountUser';
import ViewAccountUser from './Dashboard/CustomerDash/Pages/addNewUser/ViewAccountUsers';
import ReceivedEnquires from './Dashboard/CustomerDash/Pages/allEnquires/ReceivedEnquires';
import { getAppearencesThunk } from './Website/redux/appearancesSlice';
import ReceivedOrders from './Dashboard/CustomerDash/Pages/Orders/ReceivedOrders';
import ReceivedOrderDetails from './Dashboard/CustomerDash/Pages/Orders/ReceivedOrderDetails';
import SimilarProductList from './Website/pages/ProductList/SimilarProductList';
import ExcessStocks from './Dashboard/CustomerDash/Pages/excessStock/ExcessStocks';
import VendorExcessDetails from './Dashboard/CustomerDash/Pages/allEnquires/VendorExcessDetails';
import Footer from './Website/components/MainComps/Footer/Footer';


export function Layout() {
    const location = useLocation();
    const dispatch = useDispatch()

    const { customer, refresh, loading } = useSelector((state) => state.customer)

    const token = localStorage.getItem("token");

    // Account pages need a login. Opened while logged out (e.g. from an email link), send the
    // visitor to the login page, which brings them back to this exact page afterwards.
    const PRIVATE_PAGES = ['/myprofile', '/addNewUser', '/editAccountUser', '/ViewAccountUser', '/userNotifications',
        '/userEnquires', '/userSchedulePO', '/schedulePoDetails', '/accountusers', '/reshedule', '/allOrders', '/orderDetails',
        '/vendorprofile', '/addNewVendor', '/vendorNotifications', '/recievedEnquiries', '/vendorEnquiryDetails',
        '/allVendorOrders', '/ExcessStocks', '/VendorExcessDetails', '/vendororderDetails', '/VendorPODetails',
        '/receivedEnquires', '/receivedOrders', '/receivedOrderdetails'];
    const needsLogin = !token && PRIVATE_PAGES.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`));

    useEffect(() => {
        if (token) {
            dispatch(getCustomerProfileThunk())
            dispatch(getNotificationCount())
        }
    }, [token, refresh])

    // Keep the notification badge fresh even if the live socket can't connect:
    // re-check on every page change and every 30 seconds while logged in
    useEffect(() => {
        if (token) dispatch(getNotificationCount())
    }, [token, location.pathname, dispatch])

    useEffect(() => {
        if (!token) return
        const timer = setInterval(() => dispatch(getNotificationCount()), 30000)
        return () => clearInterval(timer)
    }, [token, dispatch])

    useEffect(() => {
        dispatch(getAppearencesThunk())
    }, [])

    useEffect(() => {
        if (location.pathname === "/") {
            document.body.style.backgroundColor = "#080514";
            document.body.style.color = "#ffffff";
        } else {
            document.body.style.backgroundColor = "#ffffff";
            document.body.style.color = "#1a1a1a";
        }
    }, [location.pathname]);

    return (
        <>
            <ScrollToTop />
            <ToastContainer
                position="top-right"
                autoClose={2000}
                theme='dark'
            >
            </ToastContainer>
            {/* Conditionally render Header */}
            {location.pathname !== "/login" &&
                location.pathname !== "/customerRegn" &&
                location.pathname !== "/vendorRegn" &&
                location.pathname !== "/register" &&
                location.pathname !== "/customerBillingAddress" &&
                location.pathname !== "/vendorBillingAddress" &&
                location.pathname !== "/manufactureSel" &&
                location.pathname !== "/forgotPassword" &&
                location.pathname !== "/resetPassword" &&
                location.pathname !== "/resetSuccess" &&
                location.pathname !== "/verifyEmail" &&
                <>
                    <Header />
                    {location.pathname !== "/" && <div style={{ height: "140px" }} />}
                </>
            }
            {location.pathname !== "/" &&
                location.pathname !== "/login" &&
                location.pathname !== "/forgotPassword" &&
                location.pathname !== "/resetPassword" &&
                location.pathname !== "/resetSuccess" &&
                location.pathname !== "/verifyEmail" &&
                location.pathname !== "/customerRegn" &&
                location.pathname !== "/vendorRegn" &&
                location.pathname !== "/register" &&
                location.pathname !== "/customerBillingAddress" &&
                location.pathname !== "/vendorBillingAddress" &&
                location.pathname !== "/manufactureSel" && <Breadcrumbs />}

            <div className={location.pathname === "/" ? "" : "ewDarkScope"} style={{minHeight: "90vh"}}>
                {needsLogin ? (
                    <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />
                ) : (
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgotPassword" element={<ForgotPassword />} />
                    <Route path="/resetPassword" element={<ResetPassword />} />
                    <Route path="/resetSuccess" element={<ResetSuccess />} />
                    <Route path="/verifyEmail" element={<VerifyEmail />} />
                    <Route path="/customerRegn" element={<CustomerRegn />} />
                    <Route path="/register" element={<RegisterSelection />} />
                    <Route path="/vendorRegn" element={<VendorRegn />} />
                    <Route path="/customerBillingAddress" element={<CustomerBillingAddress />} />
                    <Route path="/vendorBillingAddress" element={<VendorBillingAddress />} />
                    <Route path="/manufactureSel" element={<ManufactureSel />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/aboutUs" element={<AboutUs />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/productList/:id" element={<ProductList />} />
                    <Route path="/SimilarProductList" element={<SimilarProductList />} />
                    <Route path="/subcategories/:id" element={<Subcategories />} />
                    <Route path="/productCode/:id" element={<ProductCode />} />
                    <Route path="/productCode/*" element={<ProductCode />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/bomManage" element={<BomManage />} />
                    <Route path="/fileUploadPreview" element={<FileUploadPreview />} />
                    <Route path="/quoteRequest" element={<QuoteRequest />} />
                    <Route path="/crossRefer" element={<CrossRefer />} />
                    <Route path="/bomListing" element={<BomListing />} />
                    <Route path="/prodComparision" element={<ProdComparision />} />
                    <Route path="/exInventoryBuyItem" element={<ExInventoryBuyItem />} />
                    <Route path="/exInventoryUpload" element={<ExInventoryUpload />} />
                    <Route path="/exInvFileUploadPreview" element={<ExInvFileUploadPreview />} />
                    <Route path="/exInventoryListing" element={<ExInventoryListing />} />
                    <Route path="/exInventEnquiryForm" element={<ExInventEnquiryForm />} />
                    <Route path="/wizardEnquiryForm" element={<WizardEnquiryForm />} />
                    <Route path="/wizardUpload" element={<WizardUpload />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/service" element={<Service />} />
                    <Route path="/manufacturers" element={<Manufacturers />} />

                    <Route path="/schedulePO" element={<SchedulePO />} />
                    <Route path="/scheduleAddCart" element={<ScheduleAddCart />} />
                    <Route path="/scheduleCart" element={<ScheduleCart />} />


                    <Route path="/myprofile" element={<ProfileBody />} />
                    <Route path="/addNewUser" element={<AddNewUser />} />
                    <Route path="/editAccountUser/:id" element={<EditAccountUser />} />
                    <Route path="/ViewAccountUser/:id" element={<ViewAccountUser />} />

                    <Route path="/userNotifications" element={<UserNotifications />} />
                    <Route path="/userEnquires" element={<AllEnquires />} />
                    <Route path="/userEnquires/userEnquiryDetails/:id" element={<EnquiryDetails />} />
                    <Route path="/userSchedulePO" element={<CuSchedulePO />} />
                    <Route path="/schedulePoDetails/:id" element={<PODetails />} />
                    <Route path="/accountusers" element={<Accountusers />} />
                    <Route path="/reshedule/:id" element={<Reshedule />} />
                    <Route path="/allOrders" element={<AllOrders />} />
                    <Route path="/orderDetails/:id" element={<OrderDetails />} />


                    <Route path="/vendorprofile" element={<Vendorprofile />} />
                    <Route path="/addNewVendor" element={<AddNewVendor />} />
                    <Route path="/vendorNotifications" element={<VendorNotifications />} />
                    <Route path="/recievedEnquiries" element={<AllVenEnquires />} />
                    <Route path="/vendorEnquiryDetails/:id" element={<VenEnquiryDetails />} />
                    <Route path="/allVendorOrders" element={<AllVenOrders />} />
                    <Route path="/ExcessStocks" element={<ExcessStocks />} />
                    <Route path="/VendorExcessDetails/:id" element={<VendorExcessDetails />} />
                    <Route path="/vendororderDetails" element={<VenOrderDetails />} />
                    <Route path="/VendorPODetails" element={<VenPODetails />} />
                    <Route path="/receivedEnquires" element={<ReceivedEnquires />} />
                    <Route path="/receivedOrders" element={<ReceivedOrders />} />
                    <Route path="/receivedOrderdetails/:id" element={<ReceivedOrderDetails />} />
                </Routes>
                )}
            </div>

            {location.pathname !== "/login" &&
                location.pathname !== "/customerRegn" &&
                location.pathname !== "/vendorRegn" &&
                location.pathname !== "/register" &&
                location.pathname !== "/customerBillingAddress" &&
                location.pathname !== "/vendorBillingAddress" &&
                location.pathname !== "/manufactureSel" &&
                location.pathname !== "/forgotPassword" &&
                location.pathname !== "/resetPassword" &&
                location.pathname !== "/resetSuccess" &&
                location.pathname !== "/verifyEmail" &&
                <Footer />
            }
        </>
    );
}